<template>
  <div class="content">
    <img class="bg" :src="imageUrl" />
    <div class="fixed-btn">
      <div class="btn" @click="saveImage">保存客服二维码</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      imgData: [
        {
          type: 1,
          title: '健萌客服',
          url: 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-07/c0fc91b602061b5b01fcfcc2e0263812_wh=1080_1995.jpg'
        },
        {
          type: 2,
          title: 'WE+会员客服',
          url: 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-08/072f67708ec540670dff2bd72b867cd6_wh=1080_2057.png'
        },
        {
          type: 3,
          title: '健萌客服', //江苏售后客服
          url: 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-02/510156bb374c3b837c6acca561445e13_wh=1080_2038.webp'
        },
        {
          type: 4,
          title: '健萌客服', //深圳售后客服
          url: 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-02/b3bbb93fa34b4e0ca0c078bd9d532e7a_wh=720_1303.jpg'
        },
        {
          type: 5,
          title: '综训馆客服', //综训馆客服
          url: 'https://gympic.gymcity.com.cn/uploads-add/202609/2026-09-26-zxg-cs-qrcode'
        }
      ],
      imageUrl: ''
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      let type = this.$route.query.type || 1
      let findItem = this.imgData.find((item) => {
        return item.type == type
      })
      this.imageUrl = findItem && findItem.url
      this.$betterwe.initWebViewUIConfig({
        isTransparentBottomBar: 1,
        title: findItem && findItem.title
      })
    },
    saveImage() {
      console.log('保存')
      this.$betterwe.onAppSaveImage({
        data: this.imageUrl, //分享的具体数据
        //分享的数据的格式
        //type=base64  表示图片格式是base64   type=url  表示图片格式是链接
        type: 'url'
      })
    }
  }
}
</script>
<style scoped lang="scss">
.content {
  background-color: rgb(248, 248, 248);
  min-height: 100vh;
  position: relative;
}

.fixed-btn {
  background-color: #fff;
  padding: 6px 24px 20px;
  width: 100%;
  box-sizing: border-box;
  position: fixed;
  left: 50%;
  bottom: 0px;
  transform: translate(-50%, 0%);
  z-index: 99;

  .btn {
    background-color: rgb(98, 54, 255);
    height: 44px;
    border-radius: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    font-weight: bold;
    color: #fff;
  }
}

.bg {
  width: 100%;
}

.not-image {
  margin-top: 200px;
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
}
</style>
